import { render } from "./DetailTicketAdminView.vue?vue&type=template&id=5bf39c7a&scoped=true"
import script from "./DetailTicketAdminView.vue?vue&type=script&lang=js"
export * from "./DetailTicketAdminView.vue?vue&type=script&lang=js"

import "./DetailTicketAdminView.vue?vue&type=style&index=0&id=5bf39c7a&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf39c7a"]])

export default __exports__